import { API_ROOT } from ".";

// const api_url = API_ROOT + "/inquiries/form"
const api_url = API_ROOT + "/widgets"

const getinquiriesForm = async (bearerToken, formId) => {
    
    const form_api_url = api_url + '/' + formId;
    const postData = {
    }
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + bearerToken);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
    };

    try {
        const response = await fetch(form_api_url, requestOptions);
        const json = await response.json();
        if(json.hasOwnProperty('errors'))
        {
            var errors = json.errors;
            if(errors[0].message.includes("E_UNAUTHORIZED_ACCESS"))
            {
                localStorage.setItem('clientBearerToken', '');
                localStorage.setItem('clientFormId', '');
                localStorage.setItem('clientTokenExpiresAt', '');
                return false;
            }
        }
        return json;

    } catch (error) {
        console.log("error", error);
    }
};

export default getinquiriesForm;